import { ky } from './ky';

export interface PushTopicResponse {
  id: number;
  name: string;
  description: string;
  isSubscribed: boolean;
}

export default class PushService {
  /**
   * 푸시 토픽 목록 및 구독 여부 조회
   */
  async getPushTopics() {
    return await ky.get('v1/push-topics').json() as PushTopicResponse[];
  }

  /**
   * 특정 토픽 구독/해지
   * @param topicId 토픽 ID
   * @param isSubscribed 변경할 구독 상태
   */
  async subscribe(topicId: number, isSubscribed: boolean) {
    return await ky.post('v1/push-topics/subscribe', {
      json: { topicId, isSubscribed },
    });
  }

  /**
   * 모든 토픽 구독
   */
  async subscribeAll() {
    return await ky.post('v1/push-topics/subscribe-all');
  }
}
